import React, { useState } from "react";
import { IAutomationTask } from "../../interfaces/IAutomationTask";
import { IRole } from "../../interfaces/IRole";
import { ITaskState } from "../../interfaces/ITaskState";
import { ITaskType } from "../../interfaces/ITaskType";
import { ITaskPriority } from "../../interfaces/ITaskPriority";
import { Button, Dialog, DialogActions, DialogContent, IconButton, TableCell, TableRow } from "@mui/material";
import { Delete, Edit } from "@mui/icons-material";
import { AutomationTaskEdit } from "./AutomationTaskEdit";

interface IProps {
    autoTask: IAutomationTask;
    autoTaskArray: IAutomationTask[];
    setAutoTaskArray: Function;
    roleArray: IRole[];
    taskStateArray: ITaskState[];
    taskTypeArray: ITaskType[];
    taskPriorityArray: ITaskPriority[];
}

export const AutomationTaskRow: React.FC<IProps> = ({
    autoTask,
    autoTaskArray,
    setAutoTaskArray,
    roleArray,
    taskStateArray,
    taskTypeArray,
    taskPriorityArray,
}) => {
    const [editAutoTask, setEditAutoTask] = useState(autoTask);
    const [isOpenEdit, setIsOpenEdit] = useState(false);

    const handleOpen = () => {
        setEditAutoTask(autoTask);
        setIsOpenEdit(true);
    };
    const handleSave = () => {
        setAutoTaskArray([...autoTaskArray.map((x) => (x.id === editAutoTask.id ? editAutoTask : x))]);
        setIsOpenEdit(false);
    };

    const handleRemoveMe = () => {
        setAutoTaskArray([...autoTaskArray.filter((x) => x.id !== editAutoTask.id)]);
    };

    return (
        <>
            {isOpenEdit && (
                <Dialog open onClose={() => setIsOpenEdit(false)} maxWidth="sm" fullWidth>
                    <DialogContent>
                        <AutomationTaskEdit
                            autoTask={editAutoTask}
                            setAutoTask={setEditAutoTask}
                            roleArray={roleArray}
                            taskPriorityArray={taskPriorityArray}
                            taskStateArray={taskStateArray}
                            taskTypeArray={taskTypeArray}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button variant="outlined" onClick={() => setIsOpenEdit(false)}>
                            Abbruch
                        </Button>
                        <Button variant="contained" onClick={handleSave}>
                            Übernehmen
                        </Button>
                    </DialogActions>
                </Dialog>
            )}

            <TableRow>
                <TableCell>
                    {taskStateArray.find((taskState) => taskState.id === autoTask.TaskState)?.taskState}
                </TableCell>
                <TableCell>
                    {taskPriorityArray.find((taskPriority) => taskPriority.id === autoTask.TaskPriority)?.taskPriority}
                </TableCell>
                <TableCell>
                    {roleArray
                        .filter((role) => autoTask.task_for_roles.includes(role.id))
                        .map((role) => role.role)
                        .join(", ")}
                </TableCell>
                <TableCell>{autoTask.title}</TableCell>
                <TableCell>
                    <IconButton size="small" onClick={handleOpen}>
                        <Edit />
                    </IconButton>
                    <IconButton size="small" onClick={handleRemoveMe}>
                        <Delete />
                    </IconButton>
                </TableCell>
            </TableRow>
        </>
    );
};
